import { useComponent, useElement, useLocale } from "../../../hooks";
import { useBadgeList } from "./hooks";

export const BadgeList = () => {
  const { t } = useLocale();
  const Button = useElement("Button");
  const Link = useElement("Link");
  const Table = useComponent("Table");
  const TrashConfirmModal = useComponent("TrashConfirmModal");
  const {
    trackScrolling,
    checkedList,
    checkedAll,
    setisMultipleDelete,
    setshowTrashConfirm,
    tableContent,
    activeShownTotal,
    deleteChecked,
    trashBadge,
    trashCancel,
    showTrashConfirm,
    isMultipleDelete,
  } = useBadgeList();
  return (
    <div id="content-box" className="content" onScroll={trackScrolling}>
      <h1 className="title flex">
        All Badges
        <Link
          className="btn btn-primary btn-small ml20"
          href="/admin/badge/add"
        >
          {t("add")}
        </Link>
        {(checkedList.length !== 0 || checkedAll) && (
          <Button
            onClick={() => {
              setisMultipleDelete(true);
              setshowTrashConfirm(true);
            }}
            className="btn btn-outline btn-small"
          >
            {t("delete")}
          </Button>
        )}
      </h1>
      <Table data={tableContent} pageSize={activeShownTotal} />
      <TrashConfirmModal
        trashOkAction={() => {
          isMultipleDelete ? deleteChecked() : trashBadge();
        }}
        trashCancelAction={trashCancel}
        showTrashConfirm={showTrashConfirm}
        isMultipleDelete={isMultipleDelete}
      />
    </div>
  );
};
